import React, { Component } from 'react';
import { Modal, DatePicker, Radio, Input, InputNumber, message, Spin } from 'antd';
import HighSearchInput from '../../common/HighSearchInput';
import GoodAtAreaTable from './GoodAtAreaTable';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

const { TextArea } = Input; 
const RadioGroup = Radio.Group;
const dateFormat = "MM-DD";

class UpdateResearcher extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
        count: 0,
        list: [],
    }

    show = (record) => {
        const { birthday, reviewResearcherRecords } = record || {};
        const list = (reviewResearcherRecords || []).map((item, index) => ({
            index,
            ...item,
        }));
        const params = {
            ...(record || {}),
            birthday: birthday ? moment(birthday) : null,
        };
        this.setState({
            list,
            params,
            visible: true,
            isEdit: !!record,
            count: list.length,
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            userOptions: [],
        });
    }

    submit = () => {
        const {
            list,
            isEdit,
            params,
            userOptions = [],
        } = this.state;
        const { userId, birthday } = params;
        const { hospitalDepartmentId } = this.props;
        if (userId) {
            const isExist = userOptions.some(item => item.value == userId);
            if (!isExist) {
                message.warning('请选择正确的研究者姓名');
                return;
            }
        } else {
            message.warning('请选择研究者姓名');
            return;
        }

        let idx = 0;
        let newParams = {
            ...params,
            hospitalDepartmentId,
            birthday: birthday ? moment(birthday).format(dateFormat) : '',
        };
        for (let i = 0; i < list.length; i++) {
            const { reviewResearcherRecordId, reviewResearcherId, adeptedDomainId, investigationAreaName, adeptedDiseaseId, diseaseName, diseaseRemark, outPatientNum } = list[i];
            if (adeptedDomainId || adeptedDiseaseId || outPatientNum >= 0) {
                if (!adeptedDomainId) {
                    message.warning('请选择擅长领域');
                    return;
                }
                if (!adeptedDiseaseId) {
                    message.warning('请选择擅长疾病');
                    return;
                }
                if (!outPatientNum) {
                    message.warning('请填写月门诊量(人次)');
                    return;
                }
                if (reviewResearcherRecordId) {
                    newParams[`reviewResearcherRecords[${idx}].reviewResearcherRecordId`] = reviewResearcherRecordId;
                }
                if (reviewResearcherId) {
                    newParams[`reviewResearcherRecords[${idx}].reviewResearcherId`] = reviewResearcherId;
                }
                newParams[`reviewResearcherRecords[${idx}].adeptedDomainId`] = adeptedDomainId;
                newParams[`reviewResearcherRecords[${idx}].investigationAreaName`] = investigationAreaName;
                newParams[`reviewResearcherRecords[${idx}].adeptedDiseaseId`] = adeptedDiseaseId;
                newParams[`reviewResearcherRecords[${idx}].diseaseName`] = diseaseName;
                newParams[`reviewResearcherRecords[${idx}].diseaseRemark`] = diseaseRemark;
                newParams[`reviewResearcherRecords[${idx}].outPatientNum`] = outPatientNum;
                idx++;
            }
        }
        delete newParams.identityMap;
        delete newParams.reviewResearcherRecords;

        let url;
        if (isEdit) {
            url = API_URL.hospital.modifyReviewResearcher;
        } else {
            url = API_URL.hospital.addReviewResearcher;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url,
            data: newParams,
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData(userId);
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleDateChange = (date, dateString, key) => {
        const { params } = this.state;
        params[key] = date;
        this.setState({ params });
    }

    handleInputChange = (e, key) => {
        const { params } = this.state;
        params[key] = e.target.value;
        this.setState({ params });
    }

    handleSelectChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        this.setState({ params });
    }

    handleHighSearchInputChange = (id, options, idName, optionsName) => {
        const { params } = this.state;
        params[idName] = id;
        const option = options.find(i => i.value == id);
        const { text, identityMap } = option || {};
        params.userName = text;
        params.identityMap = identityMap;
        this.setState({
            params,
            [optionsName]: options,
        });
    }

    handleGoodAtAreaChange = (params) => {
        this.setState({ ...params });
    }

    getContent = () => {
        const { list, count, isEdit, params, visible } = this.state;
        const { hospitalDepartmentId } = this.props;
        const {
            userId,
            reviewResearcherId,
            userCompellation,
            clinicalExperience,
            gcp,
            coordination,
            cfda,
            identityMap,
            cooperationDegree,
            recommendRate,
            birthday,
            englishLevel,
            sonCount,
            dauCount,
            hobbiesAndSpecialConsiderations,
            remark,
        } = params;
        const entries = Object.entries(identityMap || {});
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left">{asterisk}研究者姓名:</div>
                    <div className="item-right">
                        {
                            visible &&
                            <HighSearchInput
                                isEdit={isEdit}
                                keyword='keyword'
                                style={{ width: 240 }}
                                params={{ limit: 20, hospitalDepartmentId, type: 'researcher', optionType: 'INSERT', reviewResearcherId }}
                                placeholder="输入姓名/手机号检索"
                                url={API_URL.hospital.queryDoctorListByHospitalDepartment}
                                initValue={{ key: userId, label: userCompellation }}
                                config={{ id: 'userId', name: 'userCompellation', type: 'researcher' }}
                                onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'userId', 'userOptions')}
                            />
                        }
                    </div>
                </li>
                <GoodAtAreaTable list={list} count={count} onChange={this.handleGoodAtAreaChange} />
                <li className="modal-item">
                    <div className="item-left">该研究者的临床试验项目经验:</div>
                    <div className="item-right">
                        <RadioGroup value={clinicalExperience} onChange={e => this.handleInputChange(e, 'clinicalExperience')}>
                            <Radio value="RICH">丰富</Radio>
                            <Radio value="COMMON">一般</Radio>
                            <Radio value="LESS">较少</Radio>
                            <Radio value="LESSER">少</Radio>
                        </RadioGroup>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">该研究者的GCP意识:</div>
                    <div className="item-right">
                        <RadioGroup value={gcp} onChange={e => this.handleInputChange(e, 'gcp')}>
                            <Radio value="STRONG">强</Radio>
                            <Radio value="MEDIUM">中</Radio>
                            <Radio value="COMMON">一般</Radio>
                            <Radio value="WEAK">差</Radio>
                        </RadioGroup>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">该研究者的配合度:</div>
                    <div className="item-right">
                        <RadioGroup value={coordination} onChange={e => this.handleInputChange(e, 'coordination')}>
                            <Radio value="GOOD">好</Radio>
                            <Radio value="MEDIUM">中</Radio>
                            <Radio value="COMMON">一般</Radio>
                            <Radio value="WEAK">差</Radio>
                        </RadioGroup>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">该研究者的CFDA视察经验:</div>
                    <div className="item-right">
                        <RadioGroup value={cfda} onChange={e => this.handleInputChange(e, 'cfda')}>
                            <Radio value="HAVE">有</Radio>
                            <Radio value="NONE">无</Radio>
                        </RadioGroup>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">该研究者在研究中角色:</div>
                    <div className="item-right">
                        {
                            entries.map((item, index) => {
                                return <span key={index} style={{ color: item[1] ? '#ccc' : '#000000a6'}}>{item[0]}{index < entries.length - 1 && '，'}</span>
                            })
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">津石合作紧密程度:</div>
                    <div className="item-right">
                        <RadioGroup value={cooperationDegree} onChange={e => this.handleInputChange(e, 'cooperationDegree')}>
                            <Radio value="BETTER">好</Radio>
                            <Radio value="GOOD">较好</Radio>
                            <Radio value="MEDIUM">中</Radio>
                            <Radio value="WEAK">差</Radio>
                        </RadioGroup>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">该研究者推荐指数:</div>
                    <div className="item-right">
                        <RadioGroup value={recommendRate} onChange={e => this.handleInputChange(e, 'recommendRate')}>
                            <Radio value="HIGHLY_RECOMMEND">极力推荐</Radio>
                            <Radio value="RECOMMEND">推荐</Radio>
                            <Radio value="COMMON">一般</Radio>
                            <Radio value="NOT_RECOMMEND">不推荐</Radio>
                        </RadioGroup>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">该研究者生日:</div>
                    <div className="item-right">
                        <DatePicker
                            placeholder="请选择"
                            style={{ width: 182 }}
                            format={dateFormat}
                            value={birthday}
                            onChange={(date, dateString) => this.handleDateChange(date, dateString, "birthday")}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">该研究者英文:</div>
                    <div className="item-right">
                        <RadioGroup value={englishLevel} onChange={e => this.handleInputChange(e, 'englishLevel')}>
                            <Radio value="GOOD">好</Radio>
                            <Radio value="MEDIUM">中</Radio>
                            <Radio value="WEAK">差</Radio>
                        </RadioGroup>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">该研究者子女:</div>
                    <div className="item-right">
                        <InputNumber
                            placeholder={`请输入`}
                            precision={0}
                            style={{ width: 100 }}
                            value={sonCount}
                            onChange={value => this.handleSelectChange(value, 'sonCount')}
                        />
                        <span style={{ margin: '0 8px 0 4px' }}>子</span>
                        <InputNumber
                            placeholder={`请输入`}
                            precision={0}
                            style={{ width: 100 }}
                            value={dauCount}
                            onChange={value => this.handleSelectChange(value, 'dauCount')}
                        />
                        <span style={{ margin: '0 8px 0 4px' }}>女</span>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ lineHeight: '20px' }}>该研究者兴趣爱好和特别&nbsp;<br/>注意事项:</div>
                    <div className="item-right">
                        <TextArea
                            rows={4}
                            maxLength="200"
                            placeholder="请输入"
                            value={hobbiesAndSpecialConsiderations}
                            onChange={e => this.handleInputChange(e, 'hobbiesAndSpecialConsiderations')}
                            style={{ width: 350, verticalAlign: 'text-top' }}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">该研究者备注:</div>
                    <div className="item-right">
                        <TextArea
                            rows={4}
                            maxLength="200"
                            placeholder="请输入"
                            value={remark}
                            onChange={e => this.handleInputChange(e, 'remark')}
                            style={{ width: 350, verticalAlign: 'text-top' }}
                        />
                    </div>
                </li>
            </ul>
        )
    }

    render() {
        const { isEdit, visible, loading } = this.state;
        return (
            <Modal
                title={`${isEdit ? '修改' : '添加'}研究者点评`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="setjde-modal addchildcontract"
                confirmLoading={loading}
                maskClosable={false}
                width="600px"
            >
                 <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default UpdateResearcher;


// WEBPACK FOOTER //
// ./src/components/hospital/commentInfo/UpdateResearcher.js